/** Copyright (c) 2019 T.Rowe Price. All rights reserved. */

import './AccountDetailsPage.scss';

import { bool } from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import AccountDetails from 'components/layouts/AccountDetails/AccountDetails';
import { getAccountForDetails, hasValidAccountForDetails } from 'state/account/AccountSelectors';
import { isBrokerage } from "services/Products";
import BrokerageAccountDetails from "components/layouts/AccountDetails/BrokerageAccountDetails/BrokerageAccountDetails";

const AccountDetailsPage = ({ validAccountForDetails, account }) => {
  if (!validAccountForDetails) return null;
  const AccountDetailsComponent = isBrokerage(account?.productType) ? BrokerageAccountDetails : AccountDetails;
  return (
    <div className="account-details-page">
      <AccountDetailsComponent />
    </div>
  );
}

AccountDetailsPage.propTypes = {
  validAccountForDetails: bool.isRequired
};

const mapStateToProps = (state) => ({
  validAccountForDetails: hasValidAccountForDetails(state),
  account: getAccountForDetails(state),
});

export default connect(mapStateToProps)(AccountDetailsPage);
